

























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Order } from '@/models/order';

@Component
export default class ReportActions extends Vue {
  @Prop({ type: Boolean, default: true }) public createButtonVisible: boolean;
}

